import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from "@angular/core";

@Component({
    selector: "counts-chart",
    templateUrl: "./counts-chart.component.html",
    styleUrls: ["./counts-chart.component.scss"],
    standalone: false
})
export class CountsChartComponent implements OnChanges {
    @Input() data: ICountsChartItem[] = [];

    @Input() colorsSchema = [
        "#359DFF",
        "#DFBC40",
        "#B77FFF",
    ];

    maxCount = 1;
    totalCount = 0;

    ngOnChanges(changes: SimpleChanges): void {
        const totalNumbers = this.data.map((item) => item.total);
        this.totalCount = totalNumbers.reduce((pre, cur) => pre + cur, 0);
        
        this.maxCount = Math.max(...totalNumbers);
    }
}

export interface ICountsChartItem {
    title: string;
    total: number;
}
